import classNames from "classnames"
import React, { ReactNode } from "react"

import CircleCheckIcon from "./Icons/CircleCheckIcon"
import Typography from "./Typography"
import { Color } from "../../../constants/V2/color"

import { getTextColorClass } from "@utils/V2/color"

type Props = {
  text: string
  size?: "body-lg" | "body-md"
  hideIcon: boolean
  iconOverrideColor?: Color
  textColor?: Color
  icon?: ReactNode
}

const TextItem = ({
  text,
  size = "body-lg",
  hideIcon,
  textColor = Color.Charcoal,
  icon = <CircleCheckIcon />,
}: Props) => {
  return (
    <div
      className={classNames(
        {
          "grid grid-cols-[min-content_auto_auto] items-center gap-x-8":
            !hideIcon,
        },
        getTextColorClass(textColor)
      )}
    >
      <div className="mb-auto">{!hideIcon && icon}</div>
      <Typography
        color={textColor}
        text={text}
        font="grotesk"
        size={size}
        weight="book"
        className="mt-px"
      />
    </div>
  )
}

export default TextItem
